/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResultStatus,
    ResultStatusFromJSON,
    ResultStatusFromJSONTyped,
    ResultStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ResultsStatusResponse
 */
export interface ResultsStatusResponse {
    /**
     * 
     * @type {ResultStatus}
     * @memberof ResultsStatusResponse
     */
    status?: ResultStatus;
    /**
     * 
     * @type {string}
     * @memberof ResultsStatusResponse
     */
    url?: string | null;
}

export function ResultsStatusResponseFromJSON(json: any): ResultsStatusResponse {
    return ResultsStatusResponseFromJSONTyped(json, false);
}

export function ResultsStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultsStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : ResultStatusFromJSON(json['status']),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ResultsStatusResponseToJSON(value?: ResultsStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': ResultStatusToJSON(value.status),
        'url': value.url,
    };
}


